import React from "react"
import Layout from "../layouts/ch"
import SEO from "../components/seo"
import { Container, Row, Col, Nav } from "react-bootstrap"
import axios from "axios"
import { Link } from "gatsby"
import { API_ROOT } from "gatsby-env-variables"
import Pagination from "react-js-pagination";
import aboutImg from "../assets/images/header.jpg";

class events extends React.Component {
    state = {
        eventList: [],
        activePage: 1,
        totalPage: 1
    }
    componentDidMount(){
        this.getEventList(1);
    }
    getEventList(page){
        axios.get(API_ROOT+`/api/v1/events`,
            {
                params: {
                    page: page
                }
            })
            .then( (response) => {
                if(response && response.data && response.data.data){
                    this.setState({
                        eventList: response.data.data,
                        totalPage: response.data.meta.total & response.data.meta.total
                    })
                }
            });
    }
    handlePageChange(pageNumber) {
        this.setState({activePage: pageNumber});
        this.getEventList(pageNumber);
    }
    render() {
        return (
            <Layout pageInfo={{ pageName: "events" }}>
                <SEO title="新闻动态" />
                <img className={'fullwidth'} src={aboutImg} alt="新闻动态"/>
                <Container fluid className={'inline-pages'}>
                    <Row>
                        <Col className={'p0 col-10 offset-1'} md={{span:10, offset:1}}>
                            <p className={'bread-crumb'}>
                                <Link to="/ch/" className="link-no-style">
                                    &nbsp;主页&nbsp;
                                </Link>/  新闻动态
                            </p>
                        </Col>
                        <Col className={'inline-pages-content-box col-10 offset-1'} md={{span:10, offset:1}} sm={{span:10, offset:1}}>
                            <Row className={'news'}>
                                {this.state.eventList && this.state.eventList.map((event, i) =>(
                                    <Col md={4} lg={4} xl={3} key={i}>
                                        <Link to={`/ch/event/${event.id}`} state={{ event: event }} className="link-no-style">
                                            <Nav.Link as="span"  eventKey="Service">
                                                <Col className={'news-card'} md={{span: 12}}>
                                                    <img src={event.picture['190x190-fit']} alt="新闻动态"/>
                                                    <p className={'blue-border-bottom'}>
                                                        {event.title_chn}
                                                    </p>
                                                    <p>
                                                        {event.short_body_chn}
                                                    </p>
                                                </Col>
                                            </Nav.Link>
                                        </Link>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                        <Col className={'inline-pages-paginate-box col-10 offset-1'} md={{span:10, offset:1}} sm={{span:10, offset:1}}>
                            <Pagination
                                activePage={this.state.activePage}
                                itemsCountPerPage={12}
                                totalItemsCount={this.state.totalPage}
                                onChange={this.handlePageChange.bind(this)}
                                prevPageText={'上一页'}
                                nextPageText={' 下一页'}
                                hideFirstLastPages={true}
                                itemClassNext={'arrows'}
                                itemClassPrev={'arrows'}
                            />
                        </Col>
                    </Row>
                </Container>
            </Layout>
        )
    }
}

export default events
